module.exports = "<div mdbProgress [animate]=\"animate\" [max]=\"max\">\n  <mdb-bar [type]=\"type\" [value]=\"value\">\n    <ng-content></ng-content>\n  </mdb-bar>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/typescripts/pro/progressbars/progressbar.component.html
// module id = ./src/app/typescripts/pro/progressbars/progressbar.component.html
// module chunks = main